export default __webpack_public_path__ + "static/Full-room-scaled-54657d3c08386bf04f44ba1b1b1af41e.jpg";